import { Icon, Input } from '@descomplica/foundation-ui-components';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';

const InputPasswordContainer = styled.div`
  position: relative;

  button {
    background: none;
    right: 4px;
    top: 18px;
    z-index: 10;
    border: none;
    position: absolute;
    cursor: pointer;
  }

  ${({ size }: Partial<{ size: string }>) => {
    switch (size) {
      case 'small':
        return css`
          button {
            transform: translateY(125%);
          }
        `;
      case 'large':
        return css``;
    }
  }}
`;

export const InputPassword: React.FC<any> = (props: any) => {
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  return (
    <InputPasswordContainer size={props.size}>
      <Input {...props} animated type={passwordShown ? 'text' : 'password'} />
      <button type="button" onClick={togglePassword}>
        <Icon size={props.size} name={passwordShown ? 'visibility-none' : 'visibility'} />
      </button>
    </InputPasswordContainer>
  );
};
